import styled, { css } from 'styled-components';
import { DismissRegular } from '@fluentui/react-icons';

const FilterTagContentCommon = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

export const FilterTagsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ClearAllTagsContent = styled.div`
  ${FilterTagContentCommon}
  cursor: pointer;
`;

export const FilterTag = styled.div`
  border: 1px solid ${(props) => props.theme.calendarDividerColor};
  border-radius: 99px;
  padding: 1px 12px;
  margin: 0 4px;
`;
export const FilterTagContent = styled.div`
  ${FilterTagContentCommon};
`;

export const FilterLabel = styled.span`
  white-space: nowrap;
  color: ${(props) => props.theme.primaryButtonBackgroundHover};
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DismissIcon = styled(DismissRegular)`
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  min-width: 16px;
`;
